import React, { Component } from "react";
import { PropTypes } from "prop-types";
import { FormGroup, Button, Image, Col, Row, FormControl, ControlLabel} from "react-bootstrap";
import { NotificationManager } from "react-notifications";
import Select from "react-select";
import debounce from "lodash/debounce";
import moment from "moment";
import DatePicker from "react-datepicker";
import SearchService from "../../../services/SearchService";
import DaysOffService from "../../../services/DaysOffService";
import DayOffTypesService from "../../../services/DayOffTypesService";
import CountriesService from "../../../services/CountriesService";
import HandleError from "../../../services/HandleError";
import InlineError from "../../messages/InlineError";
import LoaderInline from "../../helpers/LoaderInline";
import LoadingSVG from "../../helpers/LoadingSVG";
import { dataToSelectOption } from "../../helpers/HelperFunctions";

class DayOffEditForm extends Component {

    state = {
    	isLoadingDayOff: true,
    	isLoadingCountries: true,
    	isUpdatingDayOff: false,
    	isLoadingDayoffTypes: false,
    	selectedType: null,
    	selectedUser: null,
    	formData:{},
    	errors: {},
    	countries: [],
    	dayOffTypes: []
    }
	
    componentDidMount() { 
    	this.getDayOff(); 
    	this.getCountries(); 
    	this.getDayOffTypes();
    }

    onChange = (e) => { this.setState({ formData: {...this.state.formData, [e.target.name]: e.target.value} }); }
    	
	onDateChange = (date,name) => {
		if(date) {
			const formatedDate = moment(date).format("YYYY-MM-DD");
			this.setState({ 
				[name]: date,
				formData: {
					...this.state.formData, 
					[name]: formatedDate
				} 
			});
		}
	}

	onTypeChange = (option, name) => {
		if(option !== null) {
			this.setState({ selectedType: option.value, formData: { ...this.state.formData, [name]: option.value || "" }});
		} else {
			this.setState({ selectedType: null, formData: { ...this.state.formData, [name]: null }});
		}
	}
	

	onSelectChange = (option, name, selected) => {
		if (option !== null) {
			this.setState({ [selected]: option, formData: { ...this.state.formData, [name]: option.value || "" }});
		} else {
			this.setState({ [selected]: option, formData: { ...this.state.formData, [name]: null }});
		}
	};

	onUserChange = (option, name, selected) => {
		if (option !== null) {
			this.setState({ [selected]: option, formData: { ...this.state.formData, [name]: option.id || "" }});
		} else {
			this.setState({ [selected]: option, formData: { ...this.state.formData, [name]: null }});
		}
	};

	onSubmit = (e) => {
		e.preventDefault();
		const errors = this.validateDate(this.state.start, this.state.end);
		this.setState({ errors });
		if(Object.keys(errors).length === 0) {
			this.setState({ isUpdatingDayOff: true, errors: {} });
			const { dayOffId } = this.props.match.params;		
			this.dayoffService.update(dayOffId, this.state.formData).then((res) => {
				this.setState({ isUpdatingDayOff: false});
				NotificationManager.success("Day off updated.","Success!");
				this.props.history.push("/days-off");	 
			}).catch((err) => {
				this.setState({ isUpdatingDayOff: false });
				HandleError(err, this);
			});
		}
	}

	getDayOff = () => {
		const { dayOffId, typeId } = this.props.match.params;
		this.dayoffService.show(dayOffId, typeId).then((res) => {
			const dayOff = res.data.day_off;
			if(dayOff) {
				this.setState({
					...this.state,
					isLoadingDayOff: false,
					selectedType: dayOff.type_id || null,
					selectedUser:  dataToSelectOption(dayOff.user_id,"id", dayOff.full_name,"full_name"),
					start: moment(dayOff.start) || null,
					end: moment(dayOff.end) || null,
					formData: {
						name: dayOff.name || null,
						description: dayOff.description || null,
						start: moment(dayOff.start).format("YYYY-MM-DD"),
						end: moment(dayOff.end).format("YYYY-MM-DD"),
						country_id: dayOff.country_id || null,
						old_type_id: dayOff.type_id || null,
						type_id: dayOff.type_id || null,
						user_id: dayOff.user_id || null
					}
				});
			}
		}).catch((err) => {
			this.setState({ isLoadingDayOff: false });
			HandleError(err, this);
		});
	}
    
    getCountries = () => {
    	this.countriesService.index(0).then((res) => {
    		this.setState({
    			isLoadingCountries: false,
    			countries: this.mapCountriesToSelectOption(res.data)
    		});
    	}).catch((err) => {
    		this.setState({ isLoadingCountries: false });
    		HandleError(err, this);
    	});
    }
	
	getDayOffTypes = () => {
		this.dayOffTypesService.index(0).then((res) => {
			this.setState({ 
				isLoadingDayoffTypes: false, 
				dayOffTypes: this.mapCountriesToSelectOption(res.data) 
			});
		}).catch((err) => {
			this.setState({ isLoadingDayoffTypes: false });
			HandleError(err, this);
		});
	}
	
	handleAsyncSearch = (input = null, attribute, extra, callback) => {
		if (!input || !input.replace(/\s/g, "").length) {
		 callback(null, { complete: true });
		 return;
		}
		this.asyncCallback(input, attribute, extra, callback);
	}

	asyncCallback = debounce((input, attribute, extra, callback) => {
		this.searchService.searchByAttribute(attribute, input, extra).then((res) => {
			callback(null, {options: res.data , complete: true });
		}).catch((err) => {
			HandleError(err);
			callback(null, { complete: true });
		});
	}, 700);
		
	mapCountriesToSelectOption = (countries) => {
		if (countries && Array.isArray(countries)) {
			return countries.map((item) => ({value: item.id, label: item.name }));
		}
		return [];
	}

	validateDate = (start, end) => {
		const errors = {};
		if(start && end) {
			const startDate = moment(start);
			const endDate = moment(end);;
			if(endDate.isBefore(startDate)) {
				errors.end = "End date should be after start date.";
			}
		}
		return errors;
	};
    
    countriesService = new CountriesService(this)
	dayoffService = new DaysOffService(this);
	dayOffTypesService = new DayOffTypesService(this)
	searchService = new SearchService(this)

	render() {
		const { isLoadingDayOff, isUpdatingDayOff, formData, errors, countries, start, end, 
			isLoadingCountries, isLoadingDayoffTypes, dayOffTypes, selectedType, selectedUser
		} = this.state;
	 	return (
    		<React.Fragment>
				{isLoadingDayOff ? <LoadingSVG /> :  
					<Row>
						<form onSubmit={this.onSubmit}>
							<Col md={4} sm={12}>
								<span className="column-title">Details</span>
								{errors.days_off_error &&
									<Row>
										<Col md={12}>
											<div className="alert alert-danger alert-dayoff">
												<span><strong>Day off limit has been reached for period {moment(errors.period_start).format("DD-MM-YYYY")} - {moment(errors.period_end).format("DD-MM-YYYY")}</strong></span><br/>
												<span>Days off taken: {errors.days_off_taken} </span><br/>
												<span>Days off requested: {errors.days_off_requested || null} </span><br/>
												<span>Days off allowed to take: {errors.days_off_available || null}</span><br/>
											</div>
										</Col>
									</Row>
								}
								<FormGroup validationState={errors.name && "error"}>
									<ControlLabel>Name</ControlLabel>                                  
									<FormControl type="text" name="name" placeholder="Enter name" value={formData.name || ""} onChange={this.onChange}/>						
									{errors.name && <InlineError text={errors.name} />}								                                							
								</FormGroup>  

								<FormGroup validationState={errors.description && "error"}>
    							<ControlLabel>Description</ControlLabel>
    							<FormControl componentClass="textarea" name="description" placeholder="Enter project description" value={formData.description || ""} onChange={this.onChange}/>
									{errors.description && <InlineError text={errors.description} />}    						
								</FormGroup>

								<Row>
									<Col md={6}>
										<FormGroup validationState={errors.start && "error"}>
											<ControlLabel>Start</ControlLabel>
											<DatePicker
												selected={start}
												onChange={(date) => this.onDateChange(date,"start")}
												dateFormat="DD-MM-YYYY"
												className="form-control"
												placeholderText="Choose start day"
											/>
											{errors.start && <InlineError text={errors.start} />}		
										</FormGroup>
									</Col>
									<Col md={6}>
										<FormGroup validationState={errors.end && "error"}>
											<ControlLabel>End</ControlLabel>
											<DatePicker
												selected={end}
												onChange={(date) => this.onDateChange(date,"end")}
												dateFormat="DD-MM-YYYY"
												className="form-control"
												placeholderText="Choose end day"
											/>
											{errors.end && <InlineError text={errors.end} />}	
										</FormGroup>
									</Col>
								</Row> 
								<FormGroup validationState={errors.type_id && "error"}>
									<ControlLabel>Type</ControlLabel>
									<Select
										onChange={(option) => { this.onTypeChange(option, "type_id"); }}
										name="type_id"
										placeholder="Choose type"
										value={formData.type_id || ""}
										options={dayOffTypes}
										isLoading={isLoadingDayoffTypes}
										clearable={false}
										multi={false}
									/>
									{errors.type_id && <InlineError text={errors.type_id} />}
								</FormGroup>

								{(selectedType === 1) && 
									<FormGroup validationState={errors.country_id && "error"}>
										<ControlLabel>Country</ControlLabel>
										<Select
											onChange={(option) => { this.onSelectChange(option, "country_id", "selectedCountry"); }}
											name="country_id"
											placeholder="Choose country"
											value={formData.country_id || ""}
											options={countries}
											isLoading={isLoadingCountries}
											clearable={false}
											multi={false}
										/>
										{errors.country_id && <InlineError text={errors.country_id} />}
									</FormGroup>
								}	

								{(selectedType === 2 || selectedType === 3 || selectedType === 4) && 
									<FormGroup validationState={errors.user_id && "error"}>
										<ControlLabel>User</ControlLabel>
										<Select.Async
											onChange={(option) => { this.onUserChange(option, "user_id", "selectedUser"); }}
											name="user_id"
											placeholder="Search User"
											value={selectedUser}
											labelKey="full_name"
											valueKey="id"
											loadOptions={(e,c) => this.handleAsyncSearch(e,"user","roles=1,2,4",c)}
											clearable={false}
											multi={false}
										/>
										{errors.user_id && <InlineError text={errors.user_id} />}
									</FormGroup>	
								}	

								<Button className="btn-crud" bsStyle="primary" disabled={isUpdatingDayOff} type="submit">{isUpdatingDayOff?"Updating...":"Update"}</Button> 
								{ isUpdatingDayOff ? <LoaderInline width="30" height="30" color="#2196f3"/> :  null }																												
							</Col>	
						</form>						
					</Row>		
				}
    		</React.Fragment>
    	);
	 }
}
DayOffEditForm.propTypes = {
	match: PropTypes.shape({
		params: PropTypes.shape({
			dayOffId: PropTypes.string.isRequired,
			typeId: PropTypes.string.isRequired
		}).isRequired,
	}).isRequired,
	history: PropTypes.shape({
		push: PropTypes.func.isRequired
	}).isRequired
};
export default DayOffEditForm;


// WEBPACK FOOTER //
// ./src/components/forms/days-off/DayOffEditForm.js